import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
// import Layout from "../../components/Layout";
import CreateActionComponent from "../../components/ActionTracking/Create";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { successToast } from "helpers/Notification";
import {  useHistory } from "react-router-dom";

const Create = (props) => {
  const {
    errorMessage,
    GetEmployees,
    settings,
    SubmitGeneralForm,
    GetAllResources,
    loggedUser,
    resources
  } = props;

  const [loading, setLoading] = React.useState(false);
  let history = useHistory();

  //close load 
  useEffect(() => {
    if (errorMessage) setLoading(false);
  }, [errorMessage]);

  useEffect(() => {
    GetAllResources();
  }, [])
  // submit 
  const onSubmit = async (info) => {
    const { attachment, ...newInfo } = info
    const formData = new FormData();
    // formData.append("body", JSON.stringify(newInfo));

    // if (attachment) {
    //   for (let i = 0; i < attachment?.length; i++) {
    //     formData.append("attachment", attachment[i]);
    //   }
    // } 
    const response=await SubmitGeneralForm('api/meeting-action/', info, null);
    if(response?.status){
        successToast(response?.data?.message);
        history.push("/admin/action");
        }
       
  };

  return (
    <div className="w-full mb-12 px-4">
      <ToastContainer />
      <CreateActionComponent
        settings={settings}
        resources={resources?.data}
        GetEmployees={GetEmployees}
        loggedUser={loggedUser}
        // selectedEmployees={selectedEmployees}
        // setSelectedEmployees={setSelectedEmployees}
        onSubmit={onSubmit}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Create);
